import { useEffect, useState } from 'react';

// Loads Razorpay Checkout once; safe to call from several pages
const useRazorpayScript = () => {
  const [ready, setReady] = useState(Boolean(window.Razorpay));
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (window.Razorpay) return undefined;
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => setReady(true);
    script.onerror = () => setFailed(true);
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return { ready, failed };
};

export default useRazorpayScript;
